import React from 'react';

const AssistantPage = () => {
    return <div></div>;
};

export default AssistantPage;
